/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AcknowledgeHotHoldingAlertDto,
  AcknowledgeHotHoldingAlertResponseDto,
  HotHoldingAlertDetailResponseDto,
  OpenHotHoldingAlertResponseDto,
} from "../model";

import { axiosClient } from "../../lib/api";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * Records acknowledgedBy/acknowledgedAt and clears the alert from the dashboard. Acknowledgement is the only available action. Idempotency: acknowledging an already-acknowledged alert returns 200 with the existing acknowledgedAt.
 * @summary Manager acknowledges an open hot-holding alert
 */
export const acknowledgeHotHoldingAlertCommandControllerAcknowledge = (
  alertId: string,
  acknowledgeHotHoldingAlertDto: AcknowledgeHotHoldingAlertDto,
  signal?: AbortSignal,
) => {
  return axiosClient<AcknowledgeHotHoldingAlertResponseDto>({
    url: `/v1/hot-holding-alerts/${alertId}/acknowledge`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: acknowledgeHotHoldingAlertDto,
    signal,
  });
};

export const getAcknowledgeHotHoldingAlertCommandControllerAcknowledgeMutationOptions =
  <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof acknowledgeHotHoldingAlertCommandControllerAcknowledge
        >
      >,
      TError,
      { alertId: string; data: AcknowledgeHotHoldingAlertDto },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof acknowledgeHotHoldingAlertCommandControllerAcknowledge>
    >,
    TError,
    { alertId: string; data: AcknowledgeHotHoldingAlertDto },
    TContext
  > => {
    const mutationKey = [
      "acknowledgeHotHoldingAlertCommandControllerAcknowledge",
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof acknowledgeHotHoldingAlertCommandControllerAcknowledge
        >
      >,
      { alertId: string; data: AcknowledgeHotHoldingAlertDto }
    > = (props) => {
      const { alertId, data } = props ?? {};

      return acknowledgeHotHoldingAlertCommandControllerAcknowledge(
        alertId,
        data,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AcknowledgeHotHoldingAlertCommandControllerAcknowledgeMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof acknowledgeHotHoldingAlertCommandControllerAcknowledge>
    >
  >;
export type AcknowledgeHotHoldingAlertCommandControllerAcknowledgeMutationBody =
  AcknowledgeHotHoldingAlertDto;
export type AcknowledgeHotHoldingAlertCommandControllerAcknowledgeMutationError =
  void;

/**
 * @summary Manager acknowledges an open hot-holding alert
 */
export const useAcknowledgeHotHoldingAlertCommandControllerAcknowledge = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof acknowledgeHotHoldingAlertCommandControllerAcknowledge
        >
      >,
      TError,
      { alertId: string; data: AcknowledgeHotHoldingAlertDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof acknowledgeHotHoldingAlertCommandControllerAcknowledge>
  >,
  TError,
  { alertId: string; data: AcknowledgeHotHoldingAlertDto },
  TContext
> => {
  return useMutation(
    getAcknowledgeHotHoldingAlertCommandControllerAcknowledgeMutationOptions(
      options,
    ),
    queryClient,
  );
};
/**
 * Returns each unacknowledged hot-holding alert with enough context to identify the entry (meal name, temperature, threshold, recorded time).
 * @summary List open (unacknowledged) hot-holding alerts for a nursery
 */
export const listOpenHotHoldingAlertsQueryControllerList = (
  nurseryId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<OpenHotHoldingAlertResponseDto[]>({
    url: `/v1/nurseries/${nurseryId}/hot-holding-alerts/open`,
    method: "GET",
    signal,
  });
};

export const getListOpenHotHoldingAlertsQueryControllerListQueryKey = (
  nurseryId: string,
) => {
  return [`/v1/nurseries/${nurseryId}/hot-holding-alerts/open`] as const;
};

export const getListOpenHotHoldingAlertsQueryControllerListQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listOpenHotHoldingAlertsQueryControllerList>
  >,
  TError = void,
>(
  nurseryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOpenHotHoldingAlertsQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListOpenHotHoldingAlertsQueryControllerListQueryKey(nurseryId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOpenHotHoldingAlertsQueryControllerList>>
  > = ({ signal }) =>
    listOpenHotHoldingAlertsQueryControllerList(nurseryId, signal);

  return {
    queryKey,
    queryFn,
    enabled: nurseryId !== null && nurseryId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listOpenHotHoldingAlertsQueryControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListOpenHotHoldingAlertsQueryControllerListQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listOpenHotHoldingAlertsQueryControllerList>>
  >;
export type ListOpenHotHoldingAlertsQueryControllerListQueryError = void;

export function useListOpenHotHoldingAlertsQueryControllerList<
  TData = Awaited<
    ReturnType<typeof listOpenHotHoldingAlertsQueryControllerList>
  >,
  TError = void,
>(
  nurseryId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOpenHotHoldingAlertsQueryControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listOpenHotHoldingAlertsQueryControllerList>
          >,
          TError,
          Awaited<
            ReturnType<typeof listOpenHotHoldingAlertsQueryControllerList>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListOpenHotHoldingAlertsQueryControllerList<
  TData = Awaited<
    ReturnType<typeof listOpenHotHoldingAlertsQueryControllerList>
  >,
  TError = void,
>(
  nurseryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOpenHotHoldingAlertsQueryControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listOpenHotHoldingAlertsQueryControllerList>
          >,
          TError,
          Awaited<
            ReturnType<typeof listOpenHotHoldingAlertsQueryControllerList>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListOpenHotHoldingAlertsQueryControllerList<
  TData = Awaited<
    ReturnType<typeof listOpenHotHoldingAlertsQueryControllerList>
  >,
  TError = void,
>(
  nurseryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOpenHotHoldingAlertsQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List open (unacknowledged) hot-holding alerts for a nursery
 */

export function useListOpenHotHoldingAlertsQueryControllerList<
  TData = Awaited<
    ReturnType<typeof listOpenHotHoldingAlertsQueryControllerList>
  >,
  TError = void,
>(
  nurseryId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOpenHotHoldingAlertsQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getListOpenHotHoldingAlertsQueryControllerListQueryOptions(
      nurseryId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns the alert metadata, the reading that breached the hot-holding floor, and the acknowledgement audit (who acknowledged it and when). Resolves acknowledged alerts too, unlike the open-alerts rail.
 * @summary Get a hot-holding alert with its triggering reading
 */
export const getHotHoldingAlertQueryControllerGet = (
  alertId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<HotHoldingAlertDetailResponseDto>({
    url: `/v1/hot-holding-alerts/${alertId}`,
    method: "GET",
    signal,
  });
};

export const getGetHotHoldingAlertQueryControllerGetQueryKey = (
  alertId: string,
) => {
  return [`/v1/hot-holding-alerts/${alertId}`] as const;
};

export const getGetHotHoldingAlertQueryControllerGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getHotHoldingAlertQueryControllerGet>>,
  TError = void,
>(
  alertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getHotHoldingAlertQueryControllerGet>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetHotHoldingAlertQueryControllerGetQueryKey(alertId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getHotHoldingAlertQueryControllerGet>>
  > = ({ signal }) => getHotHoldingAlertQueryControllerGet(alertId, signal);

  return {
    queryKey,
    queryFn,
    enabled: alertId !== null && alertId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getHotHoldingAlertQueryControllerGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetHotHoldingAlertQueryControllerGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHotHoldingAlertQueryControllerGet>>
>;
export type GetHotHoldingAlertQueryControllerGetQueryError = void;

export function useGetHotHoldingAlertQueryControllerGet<
  TData = Awaited<ReturnType<typeof getHotHoldingAlertQueryControllerGet>>,
  TError = void,
>(
  alertId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getHotHoldingAlertQueryControllerGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHotHoldingAlertQueryControllerGet>>,
          TError,
          Awaited<ReturnType<typeof getHotHoldingAlertQueryControllerGet>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetHotHoldingAlertQueryControllerGet<
  TData = Awaited<ReturnType<typeof getHotHoldingAlertQueryControllerGet>>,
  TError = void,
>(
  alertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getHotHoldingAlertQueryControllerGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHotHoldingAlertQueryControllerGet>>,
          TError,
          Awaited<ReturnType<typeof getHotHoldingAlertQueryControllerGet>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetHotHoldingAlertQueryControllerGet<
  TData = Awaited<ReturnType<typeof getHotHoldingAlertQueryControllerGet>>,
  TError = void,
>(
  alertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getHotHoldingAlertQueryControllerGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a hot-holding alert with its triggering reading
 */

export function useGetHotHoldingAlertQueryControllerGet<
  TData = Awaited<ReturnType<typeof getHotHoldingAlertQueryControllerGet>>,
  TError = void,
>(
  alertId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getHotHoldingAlertQueryControllerGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetHotHoldingAlertQueryControllerGetQueryOptions(
    alertId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
